/* @flow weak */
import { Record } from '../transit';
import { firebaseActions } from '../lib/redux-firebase';

const State = Record({
  formDisabled: false,
  error: null,
  success: null, // To get accessToken, refreshToken, whatever.
}, 'auth');

const authReducer = (state = new State(), action) => {
  switch (action.type) {

    case firebaseActions.FIREBASE_RESET_PASSWORD_START:
    case firebaseActions.FIREBASE_SIGN_IN_START:
    case firebaseActions.FIREBASE_SIGN_UP_START: {
      return state
        .set('formDisabled', true);
    }

    case firebaseActions.FIREBASE_RESET_PASSWORD_ERROR:
    case firebaseActions.FIREBASE_SIGN_IN_ERROR:
    case firebaseActions.FIREBASE_SIGN_UP_ERROR: {
      return state
        .set('formDisabled', false)
        .set('error', action.payload);
    }

    case firebaseActions.FIREBASE_RESET_PASSWORD_SUCCESS:
    case firebaseActions.FIREBASE_SIGN_IN_SUCCESS:
    case firebaseActions.FIREBASE_SIGN_UP_SUCCESS: {
      return state
        .set('formDisabled', false)
        .set('error', null)
        .set('success', action.payload);
    }

    default:
      return state;

  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/common/auth/reducer.js